import { FileQuestion } from 'lucide-react'
import { DetailSheet } from '@/patterns/dialog'
import { EmptyState } from '@/patterns/empty-state'

export function CeremonyMissingSheet({ title, onClose }: { title: string; onClose: () => void }) {
  return (
    <DetailSheet
      open
      eyebrow="Obřad"
      title={title}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <EmptyState
        icon={<FileQuestion />}
        title="Záznam se nepodařilo najít"
        description="Zavřete detail a vyberte jiný záznam ze seznamu."
      />
    </DetailSheet>
  )
}
